class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.setHeaderCartIconAccessibility();

    this.addEventListener(
      'click',
      this.handleHautukiUpsell.bind(this)
    );

    this.addEventListener(
      'click',
      this.handleHautukiClearCart.bind(this)
    );

    this.addEventListener(
      'click',
      this.handleHautukiCheckoutNotice.bind(this),
      true
    );

    this.installHautukiCheckoutNoticeStyles();

  }


  /* =========================================================
   HAUTUKI CART CLEAR
  ========================================================= */

  async handleHautukiClearCart(event) {

    const button =
      event.target.closest(
        '[data-hautuki-clear-cart]'
      );

    if (!button) return;

    event.preventDefault();

    if (button.dataset.loading === 'true') {
      return;
    }

    button.dataset.loading = 'true';
    button.disabled = true;

    const originalText =
      button.textContent;

    button.textContent =
      '削除中…';

    try {

      const sections =
        this.getSectionsToRender()
          .map((section) => section.id);

      const response =
        await fetch(
          window.Shopify.routes.root +
          'cart/clear.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              sections: sections,

              sections_url:
                window.location.pathname
            })
          }
        );

      const state =
        await response.json();

      if (!response.ok) {
        throw new Error(
          state.description ||
          state.message ||
          'Cart clear failed'
        );
      }

      if (!state.sections) {
        throw new Error(
          'Cart sections were not returned'
        );
      }

      this.renderContents(
        state
      );

    } catch (error) {

      console.error(
        'HAUTUKI clear cart error:',
        error
      );

      if (
        button &&
        button.isConnected
      ) {
        button.dataset.loading = 'false';
        button.disabled = false;
        button.textContent = originalText;
      }

      alert(
        'カートの削除に失敗しました。もう一度お試しください。'
      );
    }

  }


  handleHautukiCheckoutNotice(event) {
    const button =
      event.target.closest(
        '#CartDrawer-Checkout'
      );

    if (
      !button ||
      !this.contains(button)
    ) {
      return;
    }

    const drawer =
      button.closest(
        '.hautuki-drawer'
      );

    if (!drawer) {
      return;
    }

    const notice =
      drawer.querySelector(
        '.hautuki-purchase-notice'
      );

    if (!notice) {
      return;
    }

    if (
      button.dataset.hautukiNoticeReady ===
      'true'
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    button.dataset.hautukiNoticeReady =
      'true';

    if (!button.dataset.hautukiOriginalLabel) {
      button.dataset.hautukiOriginalLabel =
        button.innerHTML;
    }

    notice.setAttribute(
      'open',
      ''
    );

    const summary =
      notice.querySelector(
        'summary'
      );

    if (summary) {
      summary.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    const quickItems =
      notice.querySelectorAll(
        '.hautuki-notice-quick__item'
      );

    notice.classList.remove(
      'is-hautuki-notice-emphasized'
    );

    quickItems.forEach((item) => {
      item.classList.remove(
        'is-hautuki-notice-emphasized'
      );
    });

    requestAnimationFrame(() => {
      notice.classList.add(
        'is-hautuki-notice-emphasized'
      );

      quickItems.forEach((item) => {
        item.classList.add(
          'is-hautuki-notice-emphasized'
        );
      });
    });

    notice.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    button.classList.add(
      'hautuki-checkout-button--confirming'
    );

    button.innerHTML =
      '確認して購入手続きへ <span>→</span>';

    setTimeout(() => {
      notice.classList.remove(
        'is-hautuki-notice-emphasized'
      );

      quickItems.forEach((item) => {
        item.classList.remove(
          'is-hautuki-notice-emphasized'
        );
      });
    }, 3600);
  }


  installHautukiCheckoutNoticeStyles() {
    if (
      document.getElementById(
        'hautuki-checkout-notice-styles'
      )
    ) {
      return;
    }

    const style =
      document.createElement(
        'style'
      );

    style.id =
      'hautuki-checkout-notice-styles';

    style.textContent = `
      .hautuki-purchase-notice.is-hautuki-notice-emphasized {
        animation: hautukiNoticeFrame 2.55s cubic-bezier(0.2, 0.75, 0.2, 1);
      }

      .hautuki-notice-quick__item.is-hautuki-notice-emphasized {
        animation: hautukiNoticeItem 2.15s cubic-bezier(0.2, 0.75, 0.2, 1);
      }

      .hautuki-notice-quick__item.is-hautuki-notice-emphasized:nth-child(1) {
        animation-duration: 2.75s;
      }

      .hautuki-notice-quick__item.is-hautuki-notice-emphasized:nth-child(2) {
        animation-delay: 0.14s;
      }

      .hautuki-notice-quick__item.is-hautuki-notice-emphasized:nth-child(3) {
        animation-delay: 0.28s;
      }

      .hautuki-notice-quick__item.is-hautuki-notice-emphasized:nth-child(4) {
        animation-delay: 0.42s;
      }

      .hautuki-checkout-button--confirming {
        animation: hautukiCheckoutReady 0.55s ease;
      }

      @keyframes hautukiNoticeFrame {
        0% {
          box-shadow: 0 0 0 0 rgba(255, 66, 115, 0);
        }

        42% {
          box-shadow: 0 0 0 0.42rem rgba(255, 66, 115, 0.12);
        }

        100% {
          box-shadow: 0 0 0 0 rgba(255, 66, 115, 0);
        }
      }

      @keyframes hautukiNoticeItem {
        0% {
          transform: translateY(0);
          background-color: rgba(255, 66, 115, 0.035);
          box-shadow: 0 0 0 0 rgba(255, 66, 115, 0);
        }

        42% {
          transform: translateY(-0.12rem);
          background-color: rgba(255, 66, 115, 0.08);
          box-shadow: 0 0 0 0.18rem rgba(255, 66, 115, 0.055);
        }

        100% {
          transform: translateY(0);
          background-color: rgba(255, 66, 115, 0.035);
          box-shadow: 0 0 0 0 rgba(255, 66, 115, 0);
        }
      }

      @keyframes hautukiCheckoutReady {
        0% {
          transform: translateY(0);
        }

        35% {
          transform: translateY(-0.1rem);
        }

        100% {
          transform: translateY(0);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .hautuki-purchase-notice.is-hautuki-notice-emphasized,
        .hautuki-notice-quick__item.is-hautuki-notice-emphasized,
        .hautuki-checkout-button--confirming {
          animation-duration: 0.01ms;
          animation-delay: 0s;
        }
      }
    `;

    document.head.appendChild(
      style
    );
  }
  
  /* =========================================================
    HAUTUKI BUNDLE UPSELL

    1箱 → 5箱
    1箱 → 10箱
    5箱 → 10箱
  ========================================================= */

  async handleHautukiUpsell(event) {
    const button = event.target.closest(
      '.hautuki-upsell-button, .hautuki-upsell-secondary'
    );

    if (!button) return;

    event.preventDefault();

    // 연타 방지
    if (button.dataset.loading === 'true') {
      return;
    }

    const upsellBox =
      button.closest('.hautuki-upsell');

    if (!upsellBox) {
      console.error(
        'HAUTUKI upsell container not found'
      );
      return;
    }

    const currentLineKey =
      upsellBox.dataset.lineKey;

    const targetVariant =
      button.dataset.targetVariant;

    if (!currentLineKey || !targetVariant) {
      console.error(
        'HAUTUKI upsell data missing',
        {
          currentLineKey,
          targetVariant
        }
      );

      return;
    }


    /* -----------------------------------------
       클릭 즉시 UI 피드백
    ----------------------------------------- */

    button.dataset.loading = 'true';
    button.disabled = true;

    const originalHTML =
      button.innerHTML;

    button.textContent =
      '変更中…';


    try {

      /* ========================================
         STEP 1
         현재 HAUTUKI bundle line 삭제
      ======================================== */

      const removeResponse = await fetch(
        window.Shopify.routes.root +
        'cart/change.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            id: currentLineKey,
            quantity: 0
          })
        }
      );


      const removeState =
        await removeResponse.json();


      if (!removeResponse.ok) {
        throw new Error(
          removeState.description ||
          removeState.message ||
          'Current bundle removal failed'
        );
      }


      /* ========================================
         STEP 2
         목표 Variant quantity 1 추가

         동시에:
         - cart-drawer
         - cart-icon-bubble

         HTML도 Shopify에서 다시 받음
      ======================================== */

      const sections =
        this.getSectionsToRender()
          .map((section) => section.id);


      const addResponse = await fetch(
        window.Shopify.routes.root +
        'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(targetVariant),
                quantity: 1
              }
            ],

            sections: sections,

            sections_url:
              window.location.pathname
          })
        }
      );


      const addState =
        await addResponse.json();


      if (!addResponse.ok) {
        throw new Error(
          addState.description ||
          addState.message ||
          'Target bundle add failed'
        );
      }


      if (!addState.sections) {
        throw new Error(
          'Cart sections were not returned'
        );
      }


      /* ========================================
         STEP 3
         Dawn 기존 Cart Drawer 렌더링 함수 사용
      ======================================== */

      this.renderContents(
        addState
      );


    } catch (error) {

      console.error(
        'HAUTUKI upsell error:',
        error
      );


      // Drawer가 아직 교체되지 않은 경우
      // 버튼 상태 원복
      if (
        button &&
        button.isConnected
      ) {
        button.disabled = false;
        button.dataset.loading = 'false';
        button.innerHTML = originalHTML;
      }


      alert(
        'カートの更新に失敗しました。もう一度お試しください。'
      );
    }
  }


  /* =========================================================
     DAWN ORIGINAL
  ========================================================= */

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector(
        '#cart-icon-bubble'
      );

    if (!cartLink) return;


    cartLink.setAttribute(
      'role',
      'button'
    );

    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );


    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        this.open(
          cartLink
        );
      }
    );


    cartLink.addEventListener(
      'keydown',
      (event) => {

        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          event.preventDefault();

          this.open(
            cartLink
          );
        }

      }
    );
  }


  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(
        triggeredBy
      );
    }


    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );


    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute(
        'role'
      )
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }


    setTimeout(() => {
      this.classList.add(
        'animate',
        'active'
      );
    });


    this.addEventListener(
      'transitionend',
      () => {
        
        const containerToTrapFocusOn =
          this.classList.contains(
            'is-empty'
          )
            ? (
                this.querySelector(
                  '.hautuki-empty-drawer__body'
                ) ||
                this.querySelector(
                  '.drawer__inner-empty'
                )
              )
            : document.getElementById(
                'CartDrawer'
              );


        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );


        if (
          containerToTrapFocusOn &&
          focusElement
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }

      },
      {
        once: true
      }
    );


    document.body.classList.add(
      'overflow-hidden'
    );
  }


  close() {
    this.classList.remove(
      'active'
    );

    removeTrapFocus(
      this.activeElement
    );

    document.body.classList.remove(
      'overflow-hidden'
    );
  }


  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );


    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote
        .nextElementSibling
        .getAttribute('id')
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote
          .nextElementSibling
          .id
      );
    }


    cartDrawerNote.addEventListener(
      'click',
      (event) => {

        event.currentTarget
          .setAttribute(
            'aria-expanded',
            !event.currentTarget
              .closest('details')
              .hasAttribute('open')
          );

      }
    );


    cartDrawerNote.parentElement
      .addEventListener(
        'keyup',
        onKeyUpEscape
      );
  }


  renderContents(parsedState) {
    const inner =
      this.querySelector(
        '.drawer__inner'
      );


    if (
      inner &&
      inner.classList.contains(
        'is-empty'
      )
    ) {
      inner.classList.remove(
        'is-empty'
      );
    }


    this.productId =
      parsedState.id;


    this.getSectionsToRender()
      .forEach((section) => {

        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );


        if (!sectionElement) {
          return;
        }


        const sectionHTML =
          parsedState.sections?.[
            section.id
          ];


        if (!sectionHTML) {
          return;
        }


        sectionElement.innerHTML =
          this.getSectionInnerHTML(
            sectionHTML,
            section.selector
          );

      });


    setTimeout(() => {

      const overlay =
        this.querySelector(
          '#CartDrawer-Overlay'
        );


      if (overlay) {
        overlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }


      this.open();

    });
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const element =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        )
        .querySelector(
          selector
        );


    return element
      ? element.innerHTML
      : '';
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },

      {
        id: 'cart-icon-bubble',
      },
    ];
  }


  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      );
  }


  setActiveElement(element) {
    this.activeElement =
      element;
  }
}


customElements.define(
  'cart-drawer',
  CartDrawer
);



class CartDrawerItems
  extends CartItems {

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },

      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}


customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);
